
//geoserver host of bun
let geoserver_host = "/geo_bsd";

let geoserver = geoserver_host+"/geoserver/DZZH/wms";
let geoserver_local = geoserver_host+"/geoserver/bsd/wms";
let geoserver_local_tiff = geoserver_host+"/geoserver/bnu_tif/wms";
let geoserver_basic = geoserver_host+"/geoserver/";

let geoserver_test ="/zdha_geoserver/geoserver/DZZH/wms";


//export the geoserver parameters
export  {geoserver,geoserver_local,geoserver_local_tiff,geoserver_basic,geoserver_test}



// WEBPACK FOOTER //
// ./src/view/BSD/GEOConfig.js